// extracted by mini-css-extract-plugin
export var compactFilters = "_en-4";
export var detailImage = "_en-1";
export var dropdownContainer = "_en-2";
export var imageContainer = "_en-0";
export var selectedCard = "_en-3";